module.exports = __webpack_public_path__ + "img/specif_eng.d5cbc3ee.jpg";